import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  CardImgOverlay,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { get } from '../../Code/IApi';

export default class CharityCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalDetail: false,
      charityDetail: {},
    };
  }

  openDetailModal = async (e, charity) => {
    e.stopPropagation();

    const response = await get(`/charity/${charity.CharityId}`);
    response.Succeeded &&
      this.setState({ charityDetail: response.CharityInfo, modalDetail: true });
  };

  onSelect = charity => {
    this.props.onSelect && this.props.onSelect(charity);
  };

  render() {
    const { charity, selected } = this.props;
    const {
      CharityName,
      CategoryName,
      Locations,
      ShortDescription,
      LongDescription,
      LogoURL,
      Url,
      IsLocal,
    } = this.state.charityDetail;

    return (
      <Col xs="12" md="6" lg="4" className="mb-1 mb-sm-3">
        <Card className={`charity-card small ${selected ? 'selected' : ''}`}>
          {charity.LogoURL ? (
            <img
              src={charity.LogoURL}
              onError={e => {
                e.target.onerror = null;
                e.target.src = 'images/default.png';
              }}
              alt={charity.CharityName}
            />
          ) : (
            <div className="img-name">{charity.CharityName}</div>
          )}

          {!this.props.onSelect && (
            <CardImgOverlay className="text-right card-overlay">
              <UncontrolledDropdown onClick={e => e.stopPropagation()}>
                <DropdownToggle size="sm" color="primary">
                  <i className="fa fa-ellipsis-v" />
                </DropdownToggle>

                <DropdownMenu right>
                  <DropdownItem
                    tag={Link}
                    onClick={this.closeNavbar}
                    to={`/Purchase?CID=${charity.CharityId}`}>
                    Purchase
                  </DropdownItem>
                  <DropdownItem
                    tag={Link}
                    onClick={this.closeNavbar}
                    to={`/Purchase/HonorCards?CID=${charity.CharityId}`}>
                    Honor Cards
                  </DropdownItem>
                  <DropdownItem
                    tag={Link}
                    onClick={this.closeNavbar}
                    to={`/Purchase/DirectToCharityDonation?CID=${
                      charity.CharityId
                    }`}>
                    Donate Directly
                  </DropdownItem>
                  <DropdownItem
                    tag={Link}
                    onClick={this.closeNavbar}
                    to={`/Redeem?CID=${charity.CharityId}`}>
                    Redeem
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </CardImgOverlay>
          )}
          <CardBody>
            <p className="name">{charity.CharityName}</p>
            <p
              className={`short-desc`}
              style={{
                WebkitBoxOrient: 'vertical',
                marginBottom: this.props.onSelect ? '4rem' : '1.5rem',
              }}>
              {charity.ShortDescription}
            </p>
            <div className="charity-card-footer mb-3">
              <p
                className="btn-link small mb-1"
                style={{ color: '#C44042' }}
                onClick={e => this.openDetailModal(e, charity)}>
                Learn More...
              </p>
              {this.props.onSelect && (
                <Row className="justify-content-center">
                  <Button
                    color={selected ? 'success' : 'primary'}
                    size="sm"
                    onClick={() => this.onSelect(charity)}>
                    {selected
                      ? 'You have Selected this Charity'
                      : 'Select this Charity'}
                  </Button>
                </Row>
              )}
            </div>
          </CardBody>
        </Card>
        <Modal
          className="charityDetailModal"
          isOpen={this.state.modalDetail}
          toggle={() =>
            this.setState({ modalDetail: !this.state.modalDetail })
          }>
          <ModalHeader
            toggle={() =>
              this.setState({ modalDetail: !this.state.modalDetail })
            }>
            {CharityName}
          </ModalHeader>
          <ModalBody>
            <Card className="charity-card small">
              <div className="position-relative">
                {LogoURL ? (
                  <img
                    src={LogoURL}
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = 'images/default.png';
                    }}
                    alt={CharityName}
                  />
                ) : (
                  <div className="img-name">{CharityName}</div>
                )}
                {!this.props.onSelect && (
                  <CardImgOverlay className="text-right">
                    <UncontrolledDropdown onClick={e => e.stopPropagation()}>
                      <DropdownToggle
                        size="sm"
                        color="primary"
                        className="aaaa">
                        <i className="fa fa-ellipsis-v" />
                      </DropdownToggle>

                      <DropdownMenu right>
                        <DropdownItem
                          tag={Link}
                          onClick={this.closeNavbar}
                          to={`/Purchase?CID=${charity.CharityId}`}>
                          Purchase
                        </DropdownItem>
                        <DropdownItem
                          tag={Link}
                          onClick={this.closeNavbar}
                          to={`/Purchase/HonorCards?CID=${charity.CharityId}`}>
                          Honor Cards
                        </DropdownItem>
                        <DropdownItem
                          tag={Link}
                          onClick={this.closeNavbar}
                          to={`/Purchase/DirectToCharityDonation?CID=${
                            charity.CharityId
                          }`}>
                          Donate Directly
                        </DropdownItem>
                        <DropdownItem
                          tag={Link}
                          onClick={this.closeNavbar}
                          to={`/Redeem?CID=${charity.CharityId}`}>
                          Redeem
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </CardImgOverlay>
                )}
              </div>
              <CardBody>
                <p className="name">
                  <b>{CharityName}</b>
                </p>
                {CategoryName && (
                  <p>
                    <b>Charity Category:</b> {CategoryName}
                  </p>
                )}
                {IsLocal && Locations && (
                  <p>
                    <b>Location:</b> {Locations.join(', ')}
                  </p>
                )}
                <p
                  className="short-desc"
                  style={{ WebkitBoxOrient: 'vertical' }}>
                  {ShortDescription}
                </p>
                {LongDescription && (
                  <p
                    className="short-desc"
                    style={{ WebkitBoxOrient: 'vertical' }}>
                    {LongDescription}
                  </p>
                )}
                {Url && (
                  <a target="_blank" rel="noopener noreferrer" href={Url}>
                    {Url}
                  </a>
                )}
                {this.props.onSelect && (
                  <Row className="mt-3 justify-content-center">
                    <Button
                      color={selected ? 'success' : 'primary'}
                      className="d-md-block mt-3"
                      size="sm"
                      onClick={() => this.onSelect(charity)}>
                      {selected
                        ? 'You have Selected this Charity'
                        : 'Select this Charity'}
                    </Button>
                  </Row>
                )}
              </CardBody>
            </Card>
          </ModalBody>
        </Modal>
      </Col>
    );
  }
}
